import Clarity from "@microsoft/clarity";
import { getVendorSubdomain } from "../../Utilities/Platform/Request";
import { Bootstrapper } from "../Bootstrapper";

export class MicrosoftClarityBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public bootstrap(): void {
        if(typeof process.env.MICROSOFT_CLARITY_KEY === "undefined") {
            return;
        }

        Clarity.init(process.env.MICROSOFT_CLARITY_KEY);
        Clarity.setTag("subdomain", getVendorSubdomain());
    }
}
